import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { selectCategory } from '../../actions'
import { Mobile, TabletAndLarger } from '../../shared/responsive-breakpoints'
import HomeCategoriesList from './HomeCategoriesList'
import HomeCategoriesBanner from './HomeCategoriesBanner'

const HomeCategories = ({
  categories,
  categoriesData: categoriesContentfulData,
  selectCategory,
}) => {
  const [activeCategory, setActiveCategory] = useState(null)
  const { bannerButtonText, header } = categoriesContentfulData
  const categoriesDataList = categoriesContentfulData.categoriesData.map(
    category => category.fields,
  )

  const useHomepageCategories = categories => {
    useMemo(() => {
      for (let i = 0; i < categoriesDataList.length; i++) {
        for (let j = 0; j < categories.length; j++) {
          if (categoriesDataList[i].categoryName === categories[j].name) {
            categoriesDataList[i] = { ...categoriesDataList[i], categoryData: categories[j] }
          }
        }
      }
    }, [activeCategory])
    return categoriesDataList
  }

  const categoriesData = useHomepageCategories(categories)

  const changeActiveCategory = newCategory => {
    if (activeCategory?.categoryName === newCategory?.categoryName) {
      if (window.innerWidth < 768) {
        setActiveCategory(null)
      }
      return
    }
    setActiveCategory(newCategory)
  }

  return (
    <section className="dealmed-home-categories" aria-labelledby="dealmed-home-categories-heading">
      <div className="dealmed-container">
        <h2 className="dealmed-home-categories__heading" id="dealmed-home-categories-heading">
          {header}
        </h2>
      </div>
      <div className="dealmed-home-categories__top">
        <div className="dealmed-container">
          <Mobile>
            <HomeCategoriesList
              categories={categoriesData}
              activeCategory={activeCategory}
              changeActiveCategory={changeActiveCategory}
              selectCategory={selectCategory}
              bannerButtonText={bannerButtonText}
            />
          </Mobile>
          <TabletAndLarger>
            <HomeCategoriesList
              categories={categoriesData}
              activeCategory={activeCategory ?? categoriesData[0]}
              changeActiveCategory={changeActiveCategory}
              selectCategory={selectCategory}
              bannerButtonText={bannerButtonText}
            />
          </TabletAndLarger>
        </div>
      </div>
      <TabletAndLarger>
        <div className="dealmed-home-categories__bottom">
          <div className="dealmed-container">
            <HomeCategoriesBanner
              activeCategory={activeCategory ?? categoriesData[0]}
              selectCategory={selectCategory}
              bannerButtonText={bannerButtonText}
            />
          </div>
        </div>
      </TabletAndLarger>
    </section>
  )
}

const mapStateToProps = state => {
  return {
    categories: state.shopping.categories,
  }
}

export default connect(mapStateToProps, { selectCategory })(HomeCategories)
